<template>
  <iSelectCoach />
</template>

<script setup lang="ts">
import iSelectCoach from "@/views/coaching/sections/SelectCoach.vue"
</script>
